import { render, staticRenderFns } from "./AxCreateFolder.vue?vue&type=template&id=24368152&"
import script from "./AxCreateFolder.vue?vue&type=script&lang=ts&"
export * from "./AxCreateFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports